import { render, staticRenderFns } from "./Full2.vue?vue&type=template&id=589dfc56"
import script from "./Full2.vue?vue&type=script&lang=js"
export * from "./Full2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports